<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The Campaign Begins</a></p>
<p class="toc"><a href="#/chapter02">2. A Few Days’ Rest</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. To Hurl a Host Back</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Crossing the Etowah</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Through the Pine Barrens</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Collision at New Hope Church</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Moving to the Right</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Those Damned Bugles</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Criminal Blunder</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Along the Dead-Line</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Tell Mother I Am in the Front Ranks Yet</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. In the Thickest of the Fray</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Canister Rattled Like Hail</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. By God, It’s the Rebel Forward</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. God Would Have Mercy</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. A Great Blue Carpet</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. The Park Today</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix: Order of Battle</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4dcd8bd7